import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { SearchFilterFilter } from '@app/search/search-api.model';
import { SearchFilterId } from '@app/search/services/search-filters.service';
import { formatSearchFilterContentCount } from '@app/search/components/search-view/search-reactive-store/utils';

@Component({
  selector: 'dgx-search-filter-sidebar',
  templateUrl: './search-filter-sidebar.component.html',
  styleUrls: ['./search-filter-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchFilterSidebarComponent {
  @Input() public filter: SearchFilterFilter;
  @Input() public isExpanded: boolean = false;

  @Output() public toggleFilter = new EventEmitter<SearchFilterId>();
  @Output() public filterChange = new EventEmitter<SearchFilterFilter>();

  public get isRangeFilter() {
    return !!this.filter?.config?.isRangeFilter;
  }

  public get isCheckboxFilter() {
    return (
      (!this.isRangeFilter && this.filter.config?.isCheckboxFilter) || false
    );
  }

  public get isStandardFilter() {
    return !this.isRangeFilter && !this.filter.config?.isCheckboxFilter;
  }

  public get isCheckboxFilterSelected() {
    return this.isCheckboxFilter && this.filter.subitems[0].isSelected;
  }

  public get selectedOptionCount(): number {
    return this.filter.subitems.filter(({ isSelected }) => isSelected).length;
  }

  public get showCount() {
    const count = this.filter.subitems[0].model.count;

    // TODO: Will count ever be < 0?
    return count > -1;
  }

  public get contentCount() {
    const count = this.filter.subitems[0].model.count;

    return formatSearchFilterContentCount(count);
  }

  public get icon() {
    switch (this.filter.id) {
      // implement w/https://degreedjira.atlassian.net/browse/PD-88401
      // case 'ActiveLearners':
      //   return { name: 'accomplishment-circle', class: 'color-orange' };
      case 'Mentors':
        return { name: 'mentor', class: 'color-blue' };
      default:
        return undefined;
    }
  }

  public toggleFilterOptions(): void {
    this.toggleFilter.emit(this.filter.id as SearchFilterId);
  }

  public toggleCheckboxFilterSelected() {
    const option = this.filter.subitems[0];
    option.isSelected = !option.isSelected;

    this.filterChange.emit({ ...this.filter, subitems: [option] });
  }
}
